import React from "react";
import BundleLayout from "../components/layout/bundle";

function BundleOffer() {
  return <BundleLayout />;
}

export default BundleOffer;
